"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerTextForOrderStatus = exports.salesOrderTypeLabels = exports.salesOrderStatusTitleLabels = exports.salesOrderStatusLabels = void 0;
const SalesOrder_1 = require("../models/SalesOrder");
const TSalesOrderType_1 = require("./TSalesOrderType");
/**
 * Contains all labels used in the ordering module.
 *
 * Reasoning behind this is to keep all labels consistent and in one place
 * such that only need to be changed in one place.
 */
// TODO: provide a way for getting different status labels for different
//  regions or defining your own
exports.salesOrderStatusLabels = {
    notSubmitted: "",
    pending: "Pending",
    preparing: "Preparing",
    ready: "Completed Preparation",
    delivering: "Being Delivered",
    completed: "Complete",
    refunded: "Refunded",
    cancelled: "Cancelled"
};
exports.salesOrderStatusTitleLabels = {
    notSubmitted: "",
    pending: "Pending",
    preparing: "Preparing",
    ready: "Ready",
    delivering: "Delivering",
    completed: "Completed",
    refunded: "Refunded",
    cancelled: "Cancelled"
};
exports.salesOrderTypeLabels = {
    delivery: "delivery",
    pickup: "pickup"
};
const getCustomerTextForOrderStatus = (status, type) => {
    switch (status) {
        case SalesOrder_1.TSalesOrderStatus.Pending:
            return "We have your order and will start preparing it soon";
        case SalesOrder_1.TSalesOrderStatus.Preparing:
            return "Your order is in the kitchen and making it's way down the line";
        case SalesOrder_1.TSalesOrderStatus.Ready:
            return type === TSalesOrderType_1.TSalesOrderType.Delivery
                ? "Our delivery partner is picking up your order"
                : "Your order is ready to pickup in store";
        case SalesOrder_1.TSalesOrderStatus.Delivering:
            return "Your order is in transit and will be with you momentarily";
        case SalesOrder_1.TSalesOrderStatus.Completed:
            return type === TSalesOrderType_1.TSalesOrderType.Delivery
                ? "Your order has been delivered. Please enjoy"
                : "Thank your for you order. Hope you enjoy and come back anytime";
        case SalesOrder_1.TSalesOrderStatus.Refunded:
            return "Apologies for any inconvenience caused. We have gone ahead and refunded you order";
        default:
            return "";
    }
};
exports.getCustomerTextForOrderStatus = getCustomerTextForOrderStatus;
//# sourceMappingURL=labels.js.map